
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import { InferGetStaticPropsType } from "next";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { getBaseStaticProps } from "@/utils/slug";
import SiteLayout from "@/components/layout/site";
import Breadcrumb from '@/components/fasce/Breadcrumb';
import { WPLinks_COLORE, WPLinks_SIZE, WPLinks_VARIANTE } from '@/data/wp/operations/queries/fragments/link';
import ProductDetailTitle from '@/components/fasce/ProductDetailTitle';
import ProductDetailImage from '@/components/fasce/ProductDetailImage';
import ProductDetailInfo from '@/components/fasce/ProductDetailInfo';
import ProductDetailDesc from '@/components/fasce/ProductDetailDesc';
import ProductDetailTable from '@/components/fasce/ProductDetailTable';
import CardList from '@/components/fasce/CardList';
import { buildPageUrl, PageType } from '@/utils/router';

const PdpExample = ({ data }: InferGetStaticPropsType<typeof getStaticProps>) => {
  return (
    <SiteLayout pageType={PageType.PDP} data={data} seo={undefined} language={undefined}>
      <Container fixed sx={{paddingTop: '40px'}}>
        <Grid container>

          <Grid item xs={12}>
            <Breadcrumb
              breadcrumbs={[
                {
                  links: [
                    {
                      __typename: "DefaultTemplate_Fasce_Fasce_Showroom-List_Links_LinkInterno",
                      linkInterno: {
                        id: "cG9zdDoxNA==",
                        slug: "virtual-tour",
                        uri: "/virtual-tour/",
                        title: "virtual-tour"
                      },
                      label: "LED SOLUTIONS",
                      target: null,
                      variante: WPLinks_VARIANTE.plainLink,
                      colore: WPLinks_COLORE.primary,
                      dimensione: WPLinks_SIZE.large
                    }
                  ],
                },
                {
                  links: [
                    {
                      __typename: "DefaultTemplate_Fasce_Fasce_Showroom-List_Links_LinkInterno",
                      linkInterno: {
                        id: "cG9zdDoxNA==",
                        slug: "virtual-tour",
                        uri: "/virtual-tour/",
                        title: "virtual-tour"
                      },
                      label: "Apparecchi da incasso",
                      target: null,
                      variante: WPLinks_VARIANTE.plainLink,
                      colore: WPLinks_COLORE.primary,
                      dimensione: WPLinks_SIZE.large
                    }
                  ],
                },
                {
                  links: [
                    {
                      __typename: "DefaultTemplate_Fasce_Fasce_Showroom-List_Links_LinkInterno",
                      linkInterno: {
                        id: "cG9zdDoxNA==",
                        slug: "virtual-tour",
                        uri: "/virtual-tour/",
                        title: "virtual-tour"
                      },
                      label: "841 Minicomfort LED x4 - UGR<16",
                      target: null,
                      variante: WPLinks_VARIANTE.plainLink,
                      colore: WPLinks_COLORE.primary,
                      dimensione: WPLinks_SIZE.large
                    }
                  ]
                }
              ]}
            />
            <ProductDetailTitle
              title="841 Minicomfort LED x4 - UGR<16"
            />
            {/* TODO: CTA Download PDF */}
          </Grid>

          <Grid item xs={12} md={7}>
            <ProductDetailImage
              slide={[
                {
                  backgroundImage: { id: 'pdp-image', mimeType: 'image/jpeg', mediaItemUrl: '/demo/pdp-image.jpg', mediaDetails: { width: 636, height: 636 } },
                },
                {
                  backgroundImage: { id: 'pdp-image', mimeType: 'image/jpeg', mediaItemUrl: '/demo/pdp-image.jpg', mediaDetails: { width: 636, height: 636 } },
                },
                {
                  backgroundImage: { id: 'pdp-image', mimeType: 'image/jpeg', mediaItemUrl: '/demo/pdp-image.jpg', mediaDetails: { width: 636, height: 636 } },
                }
              ]}
            />
          </Grid>

          <Grid item xs={12} md={5}>
            <ProductDetailInfo
              iconList={[
                {
                  icon: 'productInfoIP20',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                },
                {
                  icon: 'productInfoCE',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                },
                {
                  icon: 'productInfoDIMM',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                },
                {
                  icon: 'productInfoENEC',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                },
                {
                  icon: 'productInfoIK07',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                },
                {
                  icon: 'productInfoLOWFLICKER',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                },
                {
                  icon: 'productInfoRG0',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                },
                {
                  icon: 'productInfoURG16',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                },
                {
                  icon: 'productInfoUV',
                  iconTooltip: '<b>Verniciatura</b> stabilizzata ai raggi UV'
                }
              ]}
              descriptionList={[
                {
                  title: "Tipologia installazione",
                  desc: "da incasso"
                },
                {
                  title: "Materiale e colore",
                  desc: `
                    <b>Corpo:</b> In lamiera di acciaio zincato, preverniciato con resina poliestere.<br />
                    <b>Ottica dark light:</b> Ad alveoli a doppia parabolicità, in alluminio speculare 99,99 antiriflesso ed antiridescente a bassa luminanza con trattamento di PVD Con pellicola di protezione della plafoniera e del lamellare.<br />
                    <b>Forniti senza staffe:</b> per l’installazione non in appoggio utilizzare le staffe acc. 326.<br />
                  `,
                },
                {
                  title: "Normative",
                  desc: "Prodotti in conformità alle norme EN60598 - CEI 34 - 21. Hanno grado di protezione secondo le norme EN60529. Classe fotobiologica: RG0",
                },
                {
                  title: "Applicazioni d'uso",
                  tag: ["INTERNO", "GESTIONE DELLA LUCE"]
                }
              ]}
            />

          </Grid>
        </Grid>
      </Container>

      <ProductDetailDesc
        mobileIcon="plus"
        title="Descrizione"
        desc="Grazie all'esperienza e alla qualità Disano uno dei prodotti leader nel suo settore, le plafoniere Minicomfort, diventa a LED: le caratteristiche di base sono quelle che hanno garantito negli anni il loro successo, e ora possono usufruire dei principali vantaggi della tecnologia LED per l'illuminazione, quali la luce di qualità, il risparmio energetico e la maggiore durata di vita. Simili caratteristiche possono essere applicate solo ad apparecchi di alto livello progettuale e realizzativo.
        Minicomfort LED è l'apparecchio ideale per uffici, strutture sanitarie e, in generale, per tutti quegli ambienti che necessitano di un'illuminazione controllata con ottiche dark light e che devono rispettare le norme vigenti in materia di abbagliamento luminoso.
        Minicomfort è facilmente inseribile a plafone, grazie anche agli accessori studiati per semplificarne l'installazione. La forma garantisce una distribuzione uniforme della luce: i LED bianchi (4000 K) generano un'illuminazione di alta qualità assicurando il massimo comfort visivo e una perfetta resa del colore (cri >80).
        Confrontando questi apparecchi con quelli più diffusi sul mercato con lampade fluorescenti T8, il risparmio energetico è più che evidente: oltre il 40% rispetto a plafoniere 4x18 W con ottica lamellare. Il risparmio è ancor più significativo se si considerano la lunga durata di vita dei LED (80mila ore) e l'assenza di manutenzione dopo l'installazione.
        Oltre ai vantaggi pratici non è certo da sottovalutare l'ottimo risultato estetico: dotati di connessione rapida l'installazione di questi apparecchi rende superflua la loro apertura.
        Una soluzione semplice e innovativa per disporre della tecnologia più avanzata in tema di illuminazione di interni."
      />

      <Container fixed sx={{marginBottom: '90px'}}>
        <Grid container rowSpacing={0}>
          <ProductDetailTable
            singleTable={[
              {
                tabTitle: "Versioni",
                tableInfo: {
                  th: ["Codice", "Cablaggio", "Kg",  "correnteNominaleDriver", "Lumen Output - K CRI", "aperturaFascio", "WTot", "Colore", "Lunghezza", "Larghezza", "Diametro", "Altezza fuori terra", "Altezza interrata", "Altezza totale", "Garanzia", "Download"],
                  tr: [
                    {
                      /* immagine: {
                        id: "",
                        altText: "",
                        mimeType: "",
                        mediaItemUrl: "/demo/pdp-image.jpg",
                        mediaDetails: {
                          width: 100,
                          height: 100
                        }
                      }, */
                      sku: "EXAMPLE-VERSIONI",
                      openModalLabel: "153533-00",
                      storeId: "10152",
                      langId: "-4",
                      breadcrumbs: "",
                      attachments: "",
                      parentProductName: "",
                      fullImage: "",
                      thumbnail: "",
                      appUso: "",
                      cablaggio: "CLD",
                      kg: "2,91",
                      correnteNominaleDriver: 'correnteNominaleDriver',
                      lumen: "LED 4093lm - 4000K - CRI>80",
                      aperturaFascio: "13°",
                      wtot: "37W",
                      colore: "Bianco",
                      lunghezza: "123cm",
                      larghezza: "40cm",
                      altezza: "1234cm",
                      diametro: "30cm",
                      paloAltezzaFuoriTerra: "1010cm",
                      paloAltezzaInterrata: "200cm",
                      paloLunghezzaTotale: "1210cm",
                      garanzia: "download-garanzia",
                      download: "download-product-detail"
                    },
                    {
                      /* immagine: {
                        id: "",
                        altText: "",
                        mimeType: "",
                        mediaItemUrl: "/demo/pdp-image.jpg",
                        mediaDetails: {
                          width: 100,
                          height: 100
                        }
                      }, */
                      sku: "EXAMPLE-VERSIONI",
                      openModalLabel: "153533-00",
                      storeId: "10152",
                      langId: "-4",
                      breadcrumbs: "",
                      attachments: "",
                      parentProductName: "",
                      fullImage: "",
                      thumbnail: "",
                      appUso: "",
                      cablaggio: "CLD",
                      kg: "2,91",
                      correnteNominaleDriver: 'correnteNominaleDriver',
                      lumen: "LED 4093lm - 4000K - CRI>80",
                      aperturaFascio: "13°",
                      wtot: "37W",
                      colore: "Marrone",
                      lunghezza: "123cm",
                      larghezza: "40cm",
                      altezza: "1234cm",
                      diametro: "30cm",
                      paloAltezzaFuoriTerra: "1010cm",
                      paloAltezzaInterrata: "200cm",
                      paloLunghezzaTotale: "1210cm",
                      garanzia: "download-garanzia",
                      download: "download-product-detail"
                    },
                    {
                      /* immagine: {
                        id: "",
                        altText: "",
                        mimeType: "",
                        mediaItemUrl: "/demo/pdp-image.jpg",
                        mediaDetails: {
                          width: 100,
                          height: 100
                        }
                      }, */
                      sku: "EXAMPLE-VERSIONI",
                      openModalLabel: "153533-00",
                      storeId: "10152",
                      langId: "-4",
                      breadcrumbs: "",
                      attachments: "",
                      parentProductName: "",
                      fullImage: "",
                      thumbnail: "",
                      appUso: "",
                      cablaggio: "CLD",
                      kg: "2,91",
                      correnteNominaleDriver: 'correnteNominaleDriver',
                      lumen: "LED 4093lm - 4000K - CRI>80",
                      aperturaFascio: "13°",
                      wtot: "37W",
                      colore: "Nero",
                      lunghezza: "123cm",
                      larghezza: "40cm",
                      altezza: "1234cm",
                      diametro: "30cm",
                      paloAltezzaFuoriTerra: "1010cm",
                      paloAltezzaInterrata: "200cm",
                      paloLunghezzaTotale: "1210cm",
                      garanzia: "download-garanzia",
                      download: "download-product-detail"
                    },
                  ],
                  activeColumns: {
                    cablaggio: true,
                    siglaCablaggio: false,
                    colore: true,
                    garanzia: true,
                    led: true,
                    correnteNominaleDriver: true,
                    aperturaFascio: true,
                    gradiAsimmetria: false,
                    potenza: false,
                    peso: true,
                    wTot: true,
                    lunghezza: true,
                    larghezza: true,
                    altezza: true,
                    diametro: true,
                    paloAltezzaFuoriTerra: true,
                    paloAltezzaInterrata: true,
                    paloLunghezzaTotale: true,
                    download: true
                  }
                }
              },
              {
                tabTitle: "Accessori",
                tableInfo: {
                  th: ["", "Codice", "Nome", "Descrizione"],
                  tr: [
                    {
                      immagine: { id: "product-detail-accessori-1", mimeType: "image/webp", mediaItemUrl: "/demo/product-detail-accessori-1.webp", mediaDetails: { width: 87, height: 87 } },
                      sku: "EXAMPLE-ACCESSORI",
                      openModalLabel: "153533-00",
                      storeId: "10152",
                      langId: "-4",
                      breadcrumbs: "",
                      attachments: "",
                      parentProductName: "",
                      fullImage: "",
                      thumbnail: "",
                      appUso: "",
                      nome: "326 Staffa",
                      descrizione: "In acciaio zincato. Set di 4 pezzi da utilizzarsi nel caso l'articolo 851 non venga installato in appoggio."
                    },
                    {
                      immagine: { id: "product-detail-accessori-2", mimeType: "image/webp", mediaItemUrl: "/demo/product-detail-accessori-2.webp", mediaDetails: { width: 87, height: 87 } },
                      sku: "EXAMPLE-ACCESSORI",
                      openModalLabel: "153533-00",
                      storeId: "10152",
                      langId: "-4",
                      breadcrumbs: "",
                      attachments: "",
                      parentProductName: "",
                      fullImage: "",
                      thumbnail: "",
                      appUso: "",
                      nome: "326 Staffa",
                      descrizione: "In acciaio zincato. Set di 4 pezzi da utilizzarsi nel caso l'articolo 851 non venga installato in appoggio."
                    },
                  ],
                  activeColumns: {
                    cablaggio: true,
                    siglaCablaggio: false,
                    colore: true,
                    garanzia: true,
                    correnteNominaleDriver: false,
                    led: true,
                    gradiAsimmetria: false,
                    potenza: false,
                    aperturaFascio: false,
                    peso: true,
                    wTot: true,
                    lunghezza: false,
                    larghezza: false,
                    altezza: false,
                    diametro: false,
                    paloAltezzaFuoriTerra: false,
                    paloAltezzaInterrata: false,
                    paloLunghezzaTotale: false,
                    download: true
                  }
                }
              },
              {
                tabTitle: "Dimensioni",
                dimensioniImg: { id: "product-detail-dimension", mimeType: "image/webp", mediaItemUrl: "/demo/product-detail-dimension.webp", mediaDetails: { width: 502, height: 502 } },
                dimensioniTable: [
                  {
                    name: "Lunghezza:",
                    value: "596 mm"
                  },
                  {
                    name: "Larghezza:",
                    value: "596 mm"
                  },
                  {
                    name: "Diametro:",
                    value: "60 mm"
                  },
                  {
                    name: "Dimensioni incasso:",
                    value: "600x600 mm"
                  },
                ]
              }
            ]}
          />
        </Grid>
      </Container>

      <CardList bgGray title="Potrebbero interessarti anche" whiteCardList={[
        {
          url: buildPageUrl(PageType.PDP),
          label: "Novita",
          img: { id: 'card-image', mimeType: 'image/webp', mediaItemUrl: '/demo/prodotto-white-card.webp', mediaDetails: { width: 255, height: 255 } },
          occhiello: "2161",
          title: "Radon HP - diffondente - UGR<22",
        },
        {
          url: buildPageUrl(PageType.PDP),
          img: { id: 'card-image', mimeType: 'image/webp', mediaItemUrl: '/demo/prodotto-white-card.webp', mediaDetails: { width: 255, height: 255 } },
          occhiello: "2161",
          title: "Radon HP - diffondente",
        },
        {
          url: buildPageUrl(PageType.PDP),
          occhiello: "2161",
          title: "Radon HP - diffondente - UGR<22",
        },
        {
          url: buildPageUrl(PageType.PDP),
          img: { id: 'card-image', mimeType: 'image/webp', mediaItemUrl: '/demo/prodotto-white-card.webp', mediaDetails: { width: 255, height: 255 } },
          occhiello: "2161",
          title: "Radon HP - diffondente - UGR<22",
        }
      ]} />

    </SiteLayout>
  );
};

export default PdpExample;

 const _getStaticProps = getBaseStaticProps;



// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/pdp/example',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  